"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactRouterDom = require("react-router-dom");

var _Item = _interopRequireDefault(require("./Item"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var PAGING_TAKE = Number(window.env['PAGING_TAKE']);

function ListCount() {
  try {
    var handleChange = function handleChange(count) {
      navigate((0, _utils.objectToQuery)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, query), {}, {
        page: 1,
        take: count
      })));
    };

    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var items = (0, _reactRedux.useSelector)(_invoices.selectItems);
    var values = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('paging-form')) || {};
    var query = (0, _utils.queryToObject)(location['search']);
    var take = values['take'] || PAGING_TAKE;

    if (!items.length) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['description']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'description'
    }, "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['control']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link']
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      isActive: take === PAGING_TAKE,
      onClick: function onClick() {
        return handleChange(PAGING_TAKE);
      }
    }, PAGING_TAKE)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link']
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      isActive: take === 20,
      onClick: function onClick() {
        return handleChange(20);
      }
    }, "20")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link']
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      isActive: take === 50,
      onClick: function onClick() {
        return handleChange(50);
      }
    }, "50"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['description']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'description'
    }, "\u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ListCount;
exports["default"] = _default;